<template>
  <div class="gs-player-section">
    <gs-field
      :label="$t('frontend_groovevideo_videos_step1_thumbnail')"
      hint="The still viewers see before they press play. A clear, bright image gets more plays."
    >
      <div class="gs-player-section__picker imagePicker">
        <image-picker
          :primary="true"
          v-model="model.settings.splashImg"
          @change="changeImage"
        ></image-picker>
      </div>
    </gs-field>

    <gs-field
      :label="$t('frontend_groovevideo_videos_step1_watermark')"
      hint="A small logo shown over the video while it plays."
    >
      <div class="gs-player-section__picker imagePicker">
        <image-picker
          :primary="true"
          v-model="model.settings.watermark.source"
          @change="changeWatermark($event)"
        ></image-picker>
      </div>
    </gs-field>

    <gs-field label="Watermark position" hint="Where the logo sits over the video.">
      <gd-dropdown
        :options="watermarkPositions"
        v-model="model.settings.watermark.position"
        size="full"
        class="text-left"
        @change="changeWatermark($event)"
      ></gd-dropdown>
    </gs-field>
  </div>
</template>

<script>
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';

export default {
  name: 'ThumbnailSection',

  components: { ImagePicker },

  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      watermarkPositions: [
        { value: 'top-left', text: this.$t('frontend_top_left') },
        { value: 'top-right', text: this.$t('frontend_top_right') },
        { value: 'bottom-left', text: this.$t('frontend_bottom_left') },
        { value: 'bottom-right', text: this.$t('frontend_bottom_right') },
      ],
    };
  },

  methods: {
    // Ported from step1.
    changeImage(value) {
      this.model.settings.splashImg = value;
      this.$store.dispatch('videoPoster', this.model.settings.splashImg);
      this.$store.dispatch('videoComponentKey');
      this.$emit('updateModel', this.model);
      this.$emit('forceRerender');
    },

    // Ported from step1's `reRednderComponent`.
    changeWatermark() {
      this.$store.dispatch('videoWatermarkSource', this.model.settings.watermark.source);
      this.$store.dispatch('videoWatermarkPosition', this.model.settings.watermark.position);
      this.$emit('updateModel', this.model);
      this.$emit('forceRerender');
    },
  },
};
</script>

<style scoped>
.gs-player-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 14px;
}
</style>
